import React from 'react';
import { ResetPasswordForm } from '../../components/auth';

export const ResetPasswordPage: React.FC = () => {
  return <ResetPasswordForm />;
};